import { render } from "./MonacoEditorDiff.vue?vue&type=template&id=3f148719&ts=true"
import script from "./MonacoEditorDiff.vue?vue&type=script&lang=ts"
export * from "./MonacoEditorDiff.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__